module.exports = __webpack_public_path__ + "2c6b3e41da7cf401967e6b4f5fd861ca.svg";